import '../src/modules/debug_config'; // Imported to initialize the module.
import '@cortex-shim/result_runtime';
import 'reflect-metadata';
import { Injectable } from '@visiba/instantiation';
Injectable.lookup = (token) => {
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	return Reflect.getMetadata('design:paramtypes', token) ?? [];
};

import { enableProdMode, ViewEncapsulation } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { Logger, StdOutChannel } from '@visiba/logger';

Logger.attachChannel(new StdOutChannel());

if (environment.production) {
	enableProdMode();
}

platformBrowserDynamic()
	.bootstrapModule(AppModule, [
		{
			defaultEncapsulation: ViewEncapsulation.None,
		},
	])
	.catch((err) => console.error(err));
